import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import DatetimePicker from 'vuetify-datetime-picker'
Vue.use(Vuetify);
Vue.use(DatetimePicker)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#5867dd",
        secondary: "#e8ecfa",
        accent: "#6600cc",
        error: "#ff397a",
        info: "#6600cc",
        success: "#0abb87",
        warning: "#ffb822"
      }
    }
  }
});
